import { ShieldAlert } from "lucide-react";
import React, { FC } from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { styled } from "@mui/material/styles";

const PREFIX = "NoAccessRoute";

const classes = {
  ErrorOutlineRounded: `${PREFIX}-ErrorOutlineRounded`,
  noDataDiv: `${PREFIX}-noDataDiv`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.ErrorOutlineRounded}`]: {
    width: 50,
    height: 50,
    color: theme.igBorders.core.default,
  },

  [`&.${classes.noDataDiv}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "inherit",
    marginTop: 20,
  },
}));

interface NoAccessRouteProps {
  message?: string;
}

export const NoAccessRoute: FC<NoAccessRouteProps> = ({ message }) => {
  return (
    <Root className={classes.noDataDiv}>
      <ShieldAlert className={classes.ErrorOutlineRounded} />
      <IgTypography>
        {message || "You do not have access to this page."}
      </IgTypography>
    </Root>
  );
};
